import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { api } from "../api/client";
import { useAuth } from "../auth/AuthContext";
import CrmLayout from "../crmLayout/CrmLayout";
import usePageTitle from "../utils/usePageTitle";

const FUSURI = [
  "Europe/Bucharest",
  "Europe/Chisinau",
  "Europe/Berlin",
  "Europe/London",
  "Europe/Paris",
];

export default function SetariPage() {
  usePageTitle("Setări");
  const { hasPerm } = useAuth();
  const poateScrie = hasPerm("settings.write");

  const [numeCompanie, setNumeCompanie] = useState("");
  const [timezone, setTimezone] = useState("Europe/Bucharest");
  const [salveaza, setSalveaza] = useState(false);
  const [mesaj, setMesaj] = useState(null); // {tip: 'ok'|'eroare', text}

  useEffect(() => {
    api
      .get("/api/settings")
      .then((d) => {
        setNumeCompanie(d.settings.numeCompanie || "iCode");
        setTimezone(d.settings.timezone || "Europe/Bucharest");
      })
      .catch(() => setMesaj({ tip: "eroare", text: "Setările nu au putut fi încărcate." }));
  }, []);

  const salveazaSetari = async (e) => {
    e.preventDefault();
    setSalveaza(true);
    setMesaj(null);
    try {
      await api.put("/api/settings", { numeCompanie, timezone });
      setMesaj({ tip: "ok", text: "Setările au fost salvate." });
    } catch (err) {
      setMesaj({ tip: "eroare", text: err.message });
    } finally {
      setSalveaza(false);
    }
  };

  return (
    <CrmLayout>
      <div className="card">
        <div className="card-header">
          <h5 className="card-title mb-0">Setări companie</h5>
        </div>
        <div className="card-body">
          {mesaj && (
            <div className={`alert ${mesaj.tip === "ok" ? "alert-success" : "alert-danger"} d-flex align-items-center gap-2`}>
              <Icon icon={mesaj.tip === "ok" ? "solar:check-circle-outline" : "solar:danger-triangle-outline"} className="icon text-xl" />
              {mesaj.text}
            </div>
          )}
          <form onSubmit={salveazaSetari}>
            <div className="mb-16">
              <label className="form-label fw-semibold text-secondary-light" htmlFor="set-nume">
                Numele companiei
              </label>
              <input
                id="set-nume"
                type="text"
                className="form-control radius-8"
                value={numeCompanie}
                onChange={(e) => setNumeCompanie(e.target.value)}
                disabled={!poateScrie}
                required
              />
            </div>
            <div className="mb-24">
              <label className="form-label fw-semibold text-secondary-light" htmlFor="set-tz">
                Fus orar pentru afișare
              </label>
              <select
                id="set-tz"
                className="form-select radius-8"
                value={timezone}
                onChange={(e) => setTimezone(e.target.value)}
                disabled={!poateScrie}
              >
                {!FUSURI.includes(timezone) && <option value={timezone}>{timezone}</option>}
                {FUSURI.map((f) => (
                  <option key={f} value={f}>{f}</option>
                ))}
              </select>
              <p className="text-secondary-light mt-8 mb-0">
                Datele se stochează în UTC; aici configurezi fusul în care se afișează.
              </p>
            </div>
            {poateScrie && (
              <button type="submit" className="btn btn-primary radius-8" disabled={salveaza}>
                {salveaza ? "Se salvează…" : "Salvează setările"}
              </button>
            )}
          </form>
        </div>
      </div>
    </CrmLayout>
  );
}
